function clean(value) {
  if (value === undefined || value === null) return null;
  const next = String(value).trim();
  return next.length ? next : null;
}

export function mergeProfileWithClinicMapping(profile, mapping) {
  const merged =
    profile && typeof profile === "object" ? { ...profile } : {};

  const subjectId = clean(mapping?.subjectId);
  const clinicStudyId = clean(mapping?.clinicStudyId);

  if (subjectId) merged.id = subjectId;
  if (clinicStudyId) merged.clinicStudyId = clinicStudyId;

  return merged;
}
